// Intelligence Calibration defaults: the one place they're defined
// (PERSONAL_NOTES.md#calibration-env-defaults). profiles.settings.intelligence
// overrides them per user; a missing value always falls back to these.
// The JSON file is also read by the CommonJS server (api/index.js).
import DEFAULTS from './calibrationDefaults.json';

export const CALIBRATION_DEFAULTS = DEFAULTS as {
  latticeHorizonHours: number;
  latticeRadiusMiles: number;
  valueOfTimePerHour: number;
};

type IntelligenceSettings = {
  lattice_horizon_hours?: number | null;
  lattice_radius_miles?: number | null;
  value_of_time_per_hour?: number | null;
} | null | undefined;

/** The user's calibration with defaults filled in. */
export const resolveCalibration = (intelligence: IntelligenceSettings) => ({
  horizonHours: intelligence?.lattice_horizon_hours || CALIBRATION_DEFAULTS.latticeHorizonHours,
  radiusMiles: intelligence?.lattice_radius_miles || CALIBRATION_DEFAULTS.latticeRadiusMiles,
  valueOfTimePerHour: intelligence?.value_of_time_per_hour ?? CALIBRATION_DEFAULTS.valueOfTimePerHour,
});
